/*
 * Removes orphaned add-on lines from the cart. Add-on lines carry a hidden
 * `_addon_for` property holding the product id they were bundled with (see
 * snippets/addon-checkboxes.liquid). Whenever the cart changes, if the anchor
 * product is no longer in the cart the add-on is zeroed out too.
 */
(function () {
  let reconciling = false;

  function reconcileAddons() {
    if (reconciling) return;
    reconciling = true;

    fetch(window.routes.cart_url + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var productIds = new Set(
          cart.items.map(function (item) {
            return String(item.product_id);
          })
        );
        var orphans = cart.items.filter(function (item) {
          return item.properties && item.properties._addon_for && !productIds.has(String(item.properties._addon_for));
        });
        if (orphans.length === 0) return;

        var updates = {};
        orphans.forEach(function (item) {
          updates[item.key] = 0;
        });
        return fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          window.location.reload();
        });
      })
      .catch(function (error) {
        console.error('cart-addon-guard:', error);
      })
      .finally(function () {
        reconciling = false;
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      reconcileAddons();
    });
  }

  function reconcileIfCartPage() {
    if (document.querySelector('cart-items') || document.querySelector('cart-drawer')) reconcileAddons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcileIfCartPage);
  } else {
    reconcileIfCartPage();
  }
})();
